import styled from '@emotion/styled';
import { colors, spacing, typography } from 'component-library';

export const TemplateControls = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.xxsmall};

  > button:first-of-type {
    width: auto;
  }
`;

export const TemplateCreateButton = styled.button<{ hasTemplates: boolean }>`
  ${typography.body.large};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  box-sizing: border-box;
  padding: 0 18px 0 12px;
  border: 0;
  border-top: ${({ hasTemplates }) =>
    hasTemplates ? `1px solid ${colors.monochrome.grey20}` : '0'};
  background: transparent;
  color: ${colors.base.black};
  text-align: left;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: ${colors.background.grey};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary.blue};
    outline-offset: -2px;
  }

  &:disabled {
    color: ${colors.monochrome.grey40};
    cursor: default;
  }
`;
